import { render, staticRenderFns } from "./SearchResultMessageItem.vue?vue&type=template&id=326c1e7e&"
import script from "./SearchResultMessageItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultMessageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports